import React, { ReactElement } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import Link from "@ui-kit/navigation/Link/Link.web";
import Icon from "@ui-kit/icons/Icon.web";

export type HeaderShareLinksProps = {
  url: string;
  description: string;
  title?: ReactElement;
};

const HeaderShareLinks = ({
  url,
  description,
  title = undefined,
}: HeaderShareLinksProps): ReactElement => {
  const { t } = useTranslation("icons");

  return (
    <>
      {title}
      <Link
        display="flex"
        isExternal
        href={`https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(
          description
        )}`}
        data-testid="twitter-share-link"
      >
        <Icon.XLogo
          aria-label={t("Twitter")}
          color="gray.500"
          boxSize="element.xl"
          data-testid="twitter-share-icon"
          aria-hidden="false"
        />
      </Link>
      <Link
        display="flex"
        isExternal
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        data-testid="facebook-share-link"
      >
        <Icon.FacebookLogo
          aria-label={t("Facebook")}
          color="gray.500"
          boxSize="element.xl"
          data-testid="facebook-share-icon"
          aria-hidden="false"
        />
      </Link>
    </>
  );
};

export default HeaderShareLinks;
